var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-fade-transition',{attrs:{"mode":"out-in"}},[(_vm.$store.state.user || _vm.render)?_c('router-view'):_c('loading-screen')],1)}
var staticRenderFns = []

export { render, staticRenderFns }